// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const incentivesClient = createTypedClient();
export const createIncentivesClient = (config) => createTypedClient(config);
